export default __webpack_public_path__ + "static/media/other_loans.3c905a69.svg";